function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M47.51 60.78c-.53.223-1.07.428-1.618.611M20.264 13.481c.481-.315.974-.614 1.48-.893M57.873 52.073a23.102 23.102 0 01-7.897 7.484M11.642 23.916a23.101 23.101 0 016.416-8.787M56.805 17.061a27.03 27.03 0 014.887 7.18M16.745 54.386a27.03 27.03 0 01-5.07-7.05M52.646 13.211c.407.282.806.573 1.198.877M21.002 58.127a27.174 27.174 0 01-1.22-.845M36.917 8c3.778 0 7.375.776 10.641 2.178M39.8 62.895a26.91 26.91 0 01-10.83-.849M35.587 52.434a7 7 0 100-14 7 7 0 000 14z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.742 50.487L16.435 36.765a6 6 0 017.845-9.06l15.615 12.212",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.21 33.175c.75-2.253 2.881-3.74 5.377-3.74 1.232 0 2.429.411 3.399 1.17M54.587 45.434a7 7 0 100-14 7 7 0 000 14z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.546 28.38a5.145 5.145 0 01-.96-2.946 6 6 0 019.694-4.729l15.615 12.212M49.742 43.487l-6.155-5.905",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.009 24.997c.969-1.563 2.607-2.563 4.578-2.563 1.232 0 2.429.412 3.399 1.171M35.413 36.412l8.174-2.978M39.775 39.823l3.812-1.389v-5l-7.43-5.642-8.026 2.925",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.132 55.746a22.398 22.398 0 0013.44 2.332 22.404 22.404 0 0013.208-6.74M19.82 20.707a22.41 22.41 0 0113.647-7.213c7.729-1.059 15.078 1.942 19.895 7.369",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

function SvgVisualization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "/img/visualization.svg";
export { SvgVisualization as ReactComponent };